import { render, staticRenderFns } from "./resReview.vue?vue&type=template&id=99ec53c8&scoped=true"
import script from "./resReview.vue?vue&type=script&lang=js"
export * from "./resReview.vue?vue&type=script&lang=js"
import style0 from "./resReview.vue?vue&type=style&index=0&id=99ec53c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ec53c8",
  null
  
)

export default component.exports